import * as e from "react";
import r from "../lib/IconBase.es.js";
import m from "../defs/TextAa.es.js";
const o = e.forwardRef((t, a) => /* @__PURE__ */ e.createElement(r, { ref: a, ...t, weights: m }));
o.displayName = "TextAaIcon";
const n = o;
export {
  n as TextAa,
  o as TextAaIcon
};
